import { DELIVERY_PROMISE, PREPARING_FILES_GUIDE_URL } from '../../lib/contact';

/**
 * Upload-screen right sidebar (300px, desktop only): the warm-grey
 * GOOD TO KNOW reassurance card. (The old empty-state "Your order" panel was
 * removed in round 9 — staff feedback: dead weight before any prints exist —
 * along with the mobile stacked variant.)
 */
export function OrderSidebar() {
  return (
    <aside className="upload__aside">
      <div className="panel panel--muted">
        <div className="panel__eyebrow eyebrow">Good to know</div>
        <div className="goodtoknow">
          <div className="goodtoknow__check">{DELIVERY_PROMISE}</div>
          <div className="goodtoknow__check">
            We flag any photo that&rsquo;s not sharp enough for the size you pick.
          </div>
          <div className="goodtoknow__check">
            Files never leave our Australian lab servers.
          </div>
          <div>
            <a href={PREPARING_FILES_GUIDE_URL} target="_blank" rel="noopener noreferrer">
              Preparing your files guide →
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
}
